import { useTranslation } from 'next-i18next/pages';
import { Modal, type ModalState } from '@ev-tech/ui-core-components/Modal';
import { IconButton } from '@ev-tech/ui-core-components/IconButton';

import { CrossNaked } from '@/icons/small/CrossNaked';
import { TRANSLATION_NAMESPACE } from '@/i18n/config';

import modalStyles from './Modal.module.css';
import imprintModalStyles from './ImprintModal.module.css';

type Props = { imprint: string; modalState: ModalState };

export const ImprintModal = ({ imprint, modalState }: Props) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE.common);
  const { isOpen, setOpen, close } = modalState;

  return (
    <Modal modal open={isOpen} onOpenChange={setOpen}>
      <div className={modalStyles.modal}>
        <div className={modalStyles.topBar}>
          <IconButton icon={<CrossNaked />} variant="tertiaryAlt" onClick={() => close()} label={t('header.navigation.button.close')} />
        </div>
        <div data-testid="page-modal-content" className={modalStyles.content}>
          <div className={imprintModalStyles.richText} data-testid="expose-provider-imprint">
            {imprint}
          </div>
        </div>
      </div>
    </Modal>
  );
};
